import { PropsWithChildren } from 'react'
import { Permission } from '@/core/types/permissions/Permission.ts'
import useHasPermissions from '@/core/hooks/useHasPermissions.ts'

interface Props {
  requiredPermissions: Permission[]
}

const RenderWithPermissions = ({
  children,
  requiredPermissions
}: Props & PropsWithChildren) => {
  const { hasPermissions } = useHasPermissions()

  if (hasPermissions(requiredPermissions)) {
    return children
  }
  return null
}

export default RenderWithPermissions
